<template>
    <i class="ico-svg-plus">
        <svg v-bind="{ width, height }" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M16.145 8.165H9.842V1.632c0-.454-.144-.965-.838-.965s-.837.51-.837.965v6.533H1.792c-.455 0-1.125.104-1.125.833s.67.836 1.125.836h6.375V16.2c0 .455-.016 1.133.837 1.133.854 0 .838-.678.838-1.133V9.834h6.303c.455 0 1.188-.086 1.188-.836s-.733-.833-1.188-.833z" :fill="color"/>
        </svg>
    </i>
</template>

<script>
export default {
    name: 'IconPlus',

    props: {
        width: {
            type: Number,
            default: 18,
        },

        height: {
            type: Number,
            default: 18,
        },

        color: {
            type: String,
            default: 'currentColor',
        },
    },
};
</script>
